import React, { useState, useEffect } from 'react'
import { Box, Select, FormControl, MenuItem, TextField, FormControlLabel, Checkbox, Button, Tooltip } from '@mui/material';
import { ToastContainer, toast } from 'react-toastify';
import axios from '../../../utils/fvAxios';
import { useNavigate } from "react-router-dom";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import AppHeader from '../../../components/AppHeader';
import { Container, Typography, Link } from '@mui/material';

export default function EmployeeFirstLogin({ Data }) {

  const [idType, setidType] = useState("1");
  const [last4dights, setlast4dights] = useState("");
  const [dightsError, set4dightsError] = useState("");
  const ChangeId = (ans) => {
    setidType(ans);
  };
  const changeIdType = (ans) => {
    if (ans?.length == 4 || ans?.length == 0) {
      setlast4dights(ans);
      set4dightsError("");
    } else {
      setlast4dights(ans);
      set4dightsError("Please enter 4 digits");
    }

  };
  const navigate = useNavigate();
  const [checked, setChecked] = React.useState(false);

  const handleChange = (event) => {
    setChecked(event?.target?.checked);
  };
  const [lname, setLName] = useState("");
  const ChangeLastName = (event) => {
    setLName(event?.target?.value);
  };
  const toastNotify = (message, isSuccess = true) => {
    if (isSuccess) {
      toast.success(message, {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    } else {
      toast.error(message, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    }
  };
  const [isLoading, setIsLoading] = React.useState(false);

  const AddEmployes = () => {
    setIsLoading(true)
    const formData = new FormData();
    formData.append("FirstName", Data[0]?.firstname);
    formData.append("LastName", Data[0]?.lastname);
    formData.append("DocumentType", Number(idType));
    formData.append("Last4Digits", Data[0]?.last4digitsofid ? Data[0]?.last4digitsofid : last4dights);
    formData.append("AckPol", checked);
    formData.append("Signature", lname);
    formData.append("hasExistingData", Data[0]?.documenttype?.length !== 0 ? true : false);
    axios.post("Employee/EmployeeAcknowledgement", formData)
      .then((res) => {
        if (res?.data?.responseCode == 100) {
          toastNotify(res?.data?.data, true);
          navigate("/EmployeeQuizzes");
          const channel = new BroadcastChannel('refresh_channel');
          channel.postMessage('refresh2');
        } else {
          toastNotify(res?.data?.responseMessage, false);
        }
      }).finally(() => {
        setIsLoading(false)
      })

  }
  let origin = window.location.origin
  return (
    <>
      <>
        <Backdrop
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={isLoading}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
        <ToastContainer />
        <AppHeader />

        <div
          className="page-title"
          style={{
            WebkitTextStrokeWidth: 0,

            bottom: "auto",
            color: "rgb(51, 51, 51)",
            fontFamily: '"Open Sans", Arial, sans-serif',
            fontSize: 14,
            fontStyle: "normal",
            fontVariantCaps: "normal",
            fontVariantLigatures: "normal",
            fontWeight: 400,
            letterSpacing: "normal",
            margin: "auto",
            orphans: 2,
            padding: 0,
            position: "relative",
            textAlign: "start",
            textDecorationColor: "initial",
            textDecorationStyle: "initial",
            textDecorationThickness: "initial",
            textIndent: 0,
            textTransform: "none",
            whiteSpace: "normal",
            widows: 2,
            width: 800,
            wordSpacing: 0
          }}
        >
          <h3
            style={{
              color: "rgb(31, 131, 188)",
              fontSize: "1.3em",
              fontWeight: "normal",
              margin: 0,
              padding: 0
            }}
            className='mx-4'
          >
            Please complete/update details below to continue accessing your account
          </h3>
          <p style={{ marginLeft: 0 }}>&nbsp;</p>
          <p style={{ marginLeft: 0 }}>&nbsp;</p>


          <div hidden={Data[0]?.last4digitsofid?.length !== 0}>
            <span style={{ color: "#3E4A62", marginBottom: "2px" }}>
              ID<small style={{ color: "red" }}>*</small>
            </span>
            <br />
            <FormControl >
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={idType}
                label="Age"
                size="small"
                sx={{
                  "& legend": { display: "none" },
                  "& fieldset": { top: 0 },
                  fontFamily: "Arial, FontAwesome",
                  width: "320px",
                }}
                onChange={(e) => ChangeId(e?.target?.value)}
              >
                <MenuItem value={"1"}>Drivers license</MenuItem>
                <MenuItem value={"2"}>Green Card</MenuItem>
                <MenuItem value={"3"}>Social Security Number</MenuItem>
                <MenuItem value={"4"}>Phone Number</MenuItem>
              </Select>
            </FormControl>
            <br />
            <br />
            <span style={{ color: "#3E4A62", marginBottom: "2px" }}>
              Last 4 Digits of ID <small style={{ color: "red" }}>*</small>
            </span>
            <br />
            <TextField
              value={last4dights}
              type='number'
              InputProps={{ inputProps: { min: "1" } }}
              onChange={(e) => changeIdType(e?.target?.value)}
              placeholder="Last 4 Digits of ID "
              sx={{
                "& legend": { display: "none" },
                "& fieldset": { top: 0 },
                fontFamily: "Arial, FontAwesome",
                width: "320px",
              }}
              variant="outlined"
              size="small"
            />
            <br />
            <span style={{ color: "red" }}>{dightsError}</span>
            <br />

          </div>
          <Container>
            <Box my={4} sx={{ textAlign: "justify" }}>
              <Typography variant="h4" component="h1" gutterBottom sx={{ color: "rgb(31, 131, 188)" }}>
                Statement of Privacy
              </Typography>
              <Typography variant="body1" paragraph>
                Protecting your private information is our priority. This Statement of Privacy applies to the
                <Link href={origin} target='blank'> {origin}</Link> website and <strong>FIRST,</strong> VERIFY and governs data collection and usage. For the purposes of this Privacy Policy, unless otherwise noted, all references to <strong>FIRST,</strong> VERIFY include
                <Link href={origin} target='blank'> {origin}</Link> and <strong>FIRST,</strong> VERIFY. The <strong>FIRST,</strong> VERIFY website is a database site. By using the
                <Link href={origin} target='blank'> {origin}</Link> website,  you consent to the data practices described in this statement.
              </Typography>

              <Typography variant="h6" className='mb-2 text-left' gutterBottom>
                Collection of your Personal Information
              </Typography>

              <Typography variant="body1" paragraph>
                <strong>FIRST,</strong> VERIFY does not collect any personally identifiable, health of financial information, unless you voluntarily provide it to us. You provide certain information to <strong>FIRST,</strong> VERIFY at least when you register with the <strong>FIRST,</strong> VERIFY website such as your name, address, email address, company information and so on. <strong>FIRST,</strong> VERIFY may also collect information from you at other points on our website that state that such information is being collected. We may gather additional personal or non-personal information in the future.
              </Typography>
              <Typography variant="body1" paragraph>
                Information about your computer hardware and software may be automatically collected by <strong>FIRST,</strong> VERIFY. This information can include: your IP address, browser type, domain names, access times and referring website addresses. This information is used for the operation of the service, to maintain quality of the service, and to provide general statistics regarding use of the <strong>FIRST,</strong> VERIFY website.
              </Typography>
              <Typography variant="body1" paragraph>
                <strong>FIRST,</strong> VERIFY encourages you to review the privacy statements of websites you choose to link to from <strong>FIRST,</strong> VERIFY so that you can understand how those websites collect, use and share your information. <strong>FIRST,</strong> VERIFY is not responsible for the privacy statements or other content on websites outside of the <strong>FIRST,</strong> VERIFY website.
              </Typography>

              <Typography variant="h6" className='mb-2 text-left' gutterBottom>
                Use of your Personal Information
              </Typography>
              <Typography variant="body1" paragraph>
                <strong>FIRST,</strong> VERIFY uses your personal information to operate its website(s) and deliver the services you have requested.
              </Typography>
              <Typography variant="body1" paragraph>
                <strong>FIRST,</strong> VERIFY may also use your personally identifiable information to inform you of other products or services available from <strong>FIRST,</strong> VERIFY and its affiliates. <strong>FIRST,</strong> VERIFY may also contact you via surveys to conduct research about your opinion of current services or of potential new services that may be offered.
              </Typography>
              <Typography variant="body1" paragraph>
                <strong>FIRST,</strong> VERIFY does not sell, rent or lease its customer lists to third parties, however information provided by you is intended for use by <strong>FIRST,</strong> VERIFY clients, affiliates, and suppliers in their businesses.
              </Typography>
              <Typography variant="body1" paragraph>
                <strong>FIRST,</strong> VERIFY may share data with trusted partners to help perform statistical analysis, send you email or postal mail, or to provide customer support. All such third parties are prohibited from using your personal information except to provide these services to <strong>FIRST,</strong> VERIFY, and they are required to maintain the confidentiality of your information.
              </Typography>
              <Typography variant="body1" paragraph>
                <strong>FIRST,</strong> VERIFY may keep track of the websites and pages our users visit within <strong>FIRST,</strong> VERIFY, in order to determine what <strong>FIRST,</strong> VERIFY features are the most popular. This data is used to deliver customized content and advertising within <strong>FIRST,</strong> VERIFY to customers whose behavior indicates that they are interested in a particular subject area.
              </Typography>
              <Typography variant="body1" paragraph>
                <strong>FIRST,</strong> VERIFY may also disclose your personal information in connection with a corporate re-organization, a merger or amalgamation with another entity, a sale of all or a substantial portion of <strong>FIRST,</strong> VERIFY assets or stock, including any due diligence exercise carried out in relation to the same, provided that the information disclosed continues to be used for the purposes permitted by this Privacy Policy by the entity acquiring the information.
              </Typography>
              <Typography variant="body1" paragraph>
                Other than to its clients as described above, <strong>FIRST,</strong> VERIFY will disclose your personal information without notice only if required to do so by law or in the good faith belief that such action is necessary to: (a) conform to the edicts of the law or comply with legal process served on <strong>FIRST,</strong> VERIFY or the site; (b) protect and defend the rights or property of <strong>FIRST,</strong> VERIFY; and, (c) act under exigent circumstances to protect the personal safety of users of <strong>FIRST,</strong> VERIFY, or the public.
              </Typography>

              <Typography variant="h6" className='mb-2 text-left' gutterBottom>
                Use of Cookies
              </Typography>
              <Typography variant="body1" paragraph>
                The <strong>FIRST,</strong> VERIFY website may use "cookies" to help you personalize your online experience. A cookie is a text file that is placed on your hard disk by a web page server. Cookies cannot be used to run programs or deliver viruses to your computer. Cookies are uniquely assigned to you, and can only be read by a web server in the domain that issued the cookie to you.
              </Typography>
              <Typography variant="body1" paragraph>
                One of the primary purposes of cookies is to provide a convenience feature to save you time. The purpose of a cookie is to tell the web server that you have returned to a specific page. For example, if you personalize <strong>FIRST,</strong> VERIFY pages, or register with <strong>FIRST,</strong> VERIFY site or services, a cookie helps <strong>FIRST,</strong> VERIFY to recall your specific information on subsequent visits. When you return to the same <strong>FIRST,</strong> VERIFY website, the information you previously provided can be retrieved so you can easily use the <strong>FIRST,</strong> VERIFY features.
              </Typography>
              <Typography variant="body1" paragraph>
                You have the ability to accept or decline cookies. Most Web browsers automatically accept cookies, but you can usually modify your browser setting to decline cookies if you prefer. If you choose to decline cookies, you may not be able to fully experience the interactive features of the <strong>FIRST,</strong> VERIFY services or websites you visit.
              </Typography>

              <Typography variant="h6" className='mb-2 text-left' gutterBottom>
                Security of your Personal Information
              </Typography>
              <Typography variant="body1" paragraph>
                <strong>FIRST,</strong> VERIFY secures your personal information from unauthorized access, use or disclosure. When personal information (such as your company information) is transmitted to other websites, it is protected through the use of encryption, such as the Secure Sockets Layer (SSL) protocol. We use industry standard practices to protect your privacy; however, we do not promise, and you should not expect, that your personal information or private communications will always remain private. We cannot ensure that all of your private communications and other personal information will never be disclosed in ways not otherwise described in this Policy. For example, we may be forced to disclose information to the government or third parties under certain circumstances, third parties may unlawfully intercept or access transmissions or private communications, or users may abuse or misuse your personal information that they unlawfully collect from the service.
              </Typography>

              <Typography variant="h6" className='mb-2 text-left' gutterBottom>
                Children’s Policy
              </Typography>
              <Typography variant="body1" paragraph>
                <strong>FIRST,</strong> VERIFY does not knowingly collect personally identifiable information from Children. If you are a Child, you must ask your parent or guardian for permission to use this website and provide verification of parental consent.
              </Typography>
              <Typography variant="body1" paragraph>
                If you are a parent or guardian and you learn that your Child has provided us with personal information, please contact us at    <a
                  style={{
                    color: "rgb(0, 0, 238)",
                    margin: 0,
                    padding: 0,
                    textDecoration: "none"
                  }}
                  href="mailto:info@firstverify.com"
                >
                  info@firstverify.com.
                </a> If we become aware that we have collected Personal Information from a Child without verification of parental consent, we take steps to remove that information from our servers.
              </Typography>
              <Typography variant="body1" paragraph>
                For purpose of this section, “Child” means an individual under the age of 18 years unless, under the privacy laws applicable to such individual, a majority to disclose personal information is attained earlier.
              </Typography>
              <Typography variant="body1" paragraph style={{ marginBottom: 0 }}>
                Without limiting the generality of the definition set forth above, an individual who has attained-
              </Typography>

              <Typography variant="body1" component="span" sx={{ marginLeft: "60px" }}>
                i &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;    age of 13 years, if he/she is governed by COPPA;<br />
              </Typography>

              <Typography variant="body1" component="span" sx={{ marginLeft: "60px" }}>
                ii &nbsp;&nbsp;&nbsp;&nbsp;  age of 16 years, if he/she is governed by GDPR; and <br />
              </Typography>

              <Typography variant="body1" component="span" sx={{ marginLeft: "60px" }}>
                iii &nbsp;&nbsp;&nbsp; such lower age than 18 years as permitted under privacy laws applicable to that<br />
              </Typography>

              <Typography variant="body1" component="span" sx={{ marginLeft: "60px" }}>
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;individual to consent to the collection of personally identifiable information;
              </Typography>

              <Typography variant="body1" paragraph>
                shall not be considered a Child.
              </Typography>

              <Typography variant="h6" component="h4" className='mb-2 text-left' gutterBottom>
                Changes to this Statement
              </Typography>
              <Typography variant="body1" paragraph>
                <strong>FIRST,</strong> VERIFY will occasionally update this Statement of Privacy to reflect company and customer feedback. <strong>FIRST,</strong> VERIFY encourages you to periodically review this Statement to be informed of how <strong>FIRST,</strong> VERIFY is protecting your information.
              </Typography>
              <Typography variant="body1" paragraph>
                You must direct suggestions, complaints, feedback or other correspondence to below address:<br />
                {/* </Typography>
              <Typography className='text-center' sx={{marginBottom:"5px",marginTop:0}}> */}
                <span style={{ marginLeft: "200px" }}> Name:<span style={{ marginLeft: "50px" }}><strong>FIRST,</strong> VERIFY Inc.</span></span> <br />
                <span style={{ marginLeft: "200px" }}> Address:<span style={{ marginLeft: "32px" }}>9211 Forest Hill Ave., Ste. 201, Richmond, VA 23235</span></span> <br />
                <span style={{ marginLeft: "200px" }}> Email: <span style={{ marginLeft: "52px" }}>info@firstverify.com</span></span> <br />
                <span style={{ marginLeft: "200px" }}> Attention: <span style={{ marginLeft: "23px" }}>Product Manager</span></span>
              </Typography>

              <Typography variant="body1" paragraph>
                Effective as of June 18, 2024
              </Typography>
            </Box>
          </Container>
          <br />
          <br />
          <div className='mx-4' style={{ paddingBottom: "30px" }}>
            <span style={{ color: "#3E4A62", marginBottom: "2px" }}>Name of person completing:</span>
            <br />
            <TextField
              value={(Data[0]?.lastname + ', ' + Data[0].firstname)}
              disabled
              sx={{
                "& legend": { display: "none" },
                "& fieldset": { top: 0 },
                fontFamily: "Arial, FontAwesome",
                width: "320px",
              }}
              variant="outlined"
              size="small"
            />

            <br />
            <br />
            <span style={{ color: "#3E4A62", marginBottom: "5px" }}>Check the box below to confirm:<small style={{ color: "red" }}>*</small></span>

            <br />

            <FormControlLabel style={{ marginLeft: "3px" }} control={<Checkbox
              checked={checked}
              onChange={handleChange}
              inputProps={{ 'aria-label': 'controlled' }}
            />} label={<b>I accept the FIRST, VERIFY privacy policy.</b>} />
            <br />
            <hr />
            <span style={{ color: "#3E4A62", marginBottom: "5px" }}>Type your full name exactly as it appears above:<small style={{ color: "red" }}>*</small></span>
            <br />
            <TextField
              value={lname} onChange={ChangeLastName}

              sx={{
                "& legend": { display: "none" },
                "& fieldset": { top: 0 },
                fontFamily: "Arial, FontAwesome",
                width: "320px",
              }}
              variant="outlined"
              size="small"
            />

            <br />
            <br />
            {/* {JSON.stringify(Data[0].last4digitsofid)} */}
            {!lname || checked == false || (Data[0]?.last4digitsofid == "" ? last4dights?.length !== 4 : Data[0]?.last4digitsofid == "") ? (<Tooltip title="Please fill all the mandatory field" followCursor>
              <span style={{ cursor: "not-allowed" }}>
                <Button
                  variant="contained"
                  sx={{ padding: "15px", marginTop: "5px", }}
                  disabled={true}
                >
                  Save
                </Button>
              </span>
            </Tooltip>) : (<Button
              variant="contained"
              sx={{ padding: "15px", marginTop: "5px" }}
              onClick={AddEmployes}
              disabled={
                !lname || checked == false
              }
            >
              Save
            </Button>)}
            {/* {!lname || (Data[0]?.last4digitsofid?.length !== 0 && dightsError?.length == 0||last4dights.length !== 4) || checked == false ? (<Tooltip title="Please fill all the mandatory field" followCursor>
              <span style={{ cursor: "not-allowed" }}>
                <Button
                  variant="contained"
                  sx={{ padding: "15px", marginTop: "5px", }}
                  disabled={true}
                >
                  Save
                </Button>
              </span>
            </Tooltip>) : (<Button
              variant="contained"
              sx={{ padding: "15px", marginTop: "5px" }}
              onClick={AddEmployes}
              disabled={
                !lname || (Data[0]?.last4digitsofid?.length !== 0 && dightsError?.length == 0||last4dights.length !== 4) || checked == false
              }
            >
              Save
            </Button>)} */}
            {/* <Button
              variant="contained"
              sx={{ padding: "15px", marginTop: "5px" }}
              onClick={AddEmployes}
              disabled={
                !lname  || checked == false
              }
            > save</Button> */}

          </div>
        </div>
      </>


    </>
  )
}
